import firebase from 'firebase'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDo7aEvhfEJtZJumj8IXEsp_MsqGiDZvI4",
    authDomain: "limotour-busan.firebaseapp.com",
    databaseURL: "https://limotour-busan.firebaseio.com",
    projectId: "limotour-busan",
    storageBucket: "limotour-busan.appspot.com",
    messagingSenderId: "1011685126419",
    appId: "1:1011685126419:web:80493486ed3aa6e34f2ae6",
    measurementId: "G-9S8HWVWMHH"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
